import { motion } from "framer-motion";
import { PROCESS_INTRO, PROCESS_STEPS } from "@/data/content";
import { useT } from "@/i18n/LanguageContext";

export const Process = () => {
  const t = useT();

  return (
    <section id="kako" data-testid="process-section" className="relative py-24 lg:py-32 wf-mesh">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span className="uppercase text-xs tracking-[0.25em] text-[#1A1A1F] font-bold">
            {t(PROCESS_INTRO.eyebrow)}
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mt-4">
            {t(PROCESS_INTRO.title)}
          </h2>
        </motion.div>

        <div data-testid="process-grid" className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {PROCESS_STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              data-testid={`process-step-${i}`}
              className="relative p-8 rounded-3xl bg-white border border-[#E8E7E2] hover:border-[#0A0A0F]/25 hover:-translate-y-1 transition-all duration-300 group"
            >
              <span className="font-heading text-6xl font-bold text-[#23262E] group-hover:text-[#0A0A0F]/30 transition-colors duration-300">
                {s.n}
              </span>
              <h3 className="font-heading text-xl font-medium mt-6">{t(s.title)}</h3>
              <p className="text-sm text-[#62646B] leading-relaxed mt-3">{t(s.desc)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
